import React from "react";
import "./Modal.scss";
import Button from "../../component/button/button";

interface ModalProps {
  title: string;
  body: React.ReactNode;
  isOpen: boolean;
  onClose: () => void;
  handleExtraButtonClick?: () => void;
  onClick?: () => void;
  width?: string;
  extraBtn?: boolean;
  extraBtnName?: string;
  extraBtnIsDisabled?: boolean;
  extraBtnType?: "primary" | "secondary" | "link";
}

const ViewModal: React.FC<ModalProps> = ({
  body,
  isOpen,
  onClose,
  width,
  extraBtn,
  extraBtnName,
  extraBtnIsDisabled,
  extraBtnType,
  handleExtraButtonClick,
}) => {
  if (!isOpen) return null;

  return (
    <div className="modal-backdrop">
      <div className="modal" style={{ width: width || "600px" }}>
        <div className="modal-body">{body}</div>

        <div className="modal-footer">
          <div className="col-span-1 md:col-span-2 text-right flex justify-end gap-2">
            {extraBtn && (
              <Button
                text={extraBtnName || "Extra Action"}
                disabled={extraBtnIsDisabled}
                buttonType="button"
                type={extraBtnType || "primary"}
                onClick={handleExtraButtonClick || (() => {})}
                style={{
                  height: 40,
                }}
              />
            )}
            <Button
              text="Close"
              buttonType="button"
              type="primary"
              onClick={onClose}
              style={{
                height: 40,
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewModal;
